function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "Trazado 295",
  d: "M3.003 8.999a3.4 3.4 0 00-1.738-2.963.849.849 0 10-.83 1.481 1.7 1.7 0 010 2.967.849.849 0 00.827 1.482A3.4 3.4 0 003.002 9zm0 0",
  fill: "#93a0b1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "Trazado 296",
  d: "M2.097 13.445a.849.849 0 00.83 1.481 6.794 6.794 0 000-11.854.849.849 0 10-.83 1.48 5.1 5.1 0 010 8.893zm0 0",
  fill: "#93a0b1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "Trazado 297",
  d: "M3.426.434a.849.849 0 00.326 1.155 8.494 8.494 0 010 14.82.85.85 0 00.831 1.481A10.191 10.191 0 004.577.108a.848.848 0 00-1.154.326zm0 0",
  fill: "#93a0b1"
});

var SvgUtterances = function SvgUtterances(props) {
  return React.createElement("svg", _extends({
    "data-name": "Grupo 437",
    width: 9.794,
    height: 17.999
  }, props), _ref, _ref2, _ref3);
};

export default SvgUtterances;